import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from "prop-types";
import axios from "axios";
import Api from "../../../assets/js/utils/Api.js";
import Auth from "../../../assets/js/utils/Auth.js";
import BackgroundSlider from "../../components/Slider/BackgroundSlider.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import userHomePageStyle from "../../../assets/jss/user/userHomePageStyle.jsx";
import ReactTable from "react-table";
import LoaderComponent from "../../components/Loader.js";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import ChartistGraph from "react-chartist";
import Button from "../../components/CustomButtons/Button";
import Menu from '@material-ui/core/Menu';
import { MenuItem as MuiMenuItem } from '@material-ui/core';

const PdfFileAnalytics = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        this.history = this.props.history;
        
        let fileId = null;
        const { match } = this.props.match;
        if(match && match.params.hasOwnProperty("id")){
            fileId = match.params.id;
        }

        this.state = {
            loading: true,
            loadingVisitorInfo: false,
            file_info: null,
            recent_visits: null,
            visitor_info: null,
            fileId: fileId,
            activeTab: 0,
            total_visits: null,
            avg_viewed: null,
            top_pages: null,
            time_per_page: null,
            drop_off_report: null,
            heatmap: null,
            filter: 'views',
            filterMenuEl: null
        }
    }
    componentDidMount(){
        const { authorized } = this.store.getState();
        if(!authorized && !Auth.hasAccessToken()){
            const location = this.history.location;
            const loginRequired = "/auth/login?return="+encodeURIComponent(location.pathname+location.search);
            this.history.push(loginRequired);
        }

        this.loadPdfFileActivity();      
    }
    loadPdfFileActivity(){
        const { fileId } = this.state;

        const source = axios.CancelToken.source();
        
        this.setState({
            loading: true, 
            showError: false, 
            cancelToken: source,
        });

        let requestData = {
            fileId: fileId
        };
        
        Api.getPdfFileActivity(requestData, source).then(data => {
            this.setState({
                file_info: data.file_info,
                recent_visits: data.recent_visits,
                visitor_info: data.visitor_info,
                loading: false,
            });
        }).catch(err => {
            console.log(err);
        });
    }
    loadPdfFilePerformance(){
        const { fileId } = this.state;

        const source = axios.CancelToken.source();
        
        this.setState({
            loading: true, 
            showError: false, 
            cancelToken: source,
        });

        let requestData = {
            fileId: fileId
        };
        
        Api.getPdfFilePerformance(requestData, source).then(data => {
            this.setState({
                total_visits: data.total_visits,
                avg_viewed: data.avg_viewed,
                top_pages: data.top_pages,
                time_per_page: data.time_per_page,
                drop_off_report: data.drop_off_report,
                loading: false,
            });
        }).catch(err => {
            console.log(err);
        });
    }
    loadPdfFileHeatmap(filter = 'views'){
        const { fileId } = this.state;

        const source = axios.CancelToken.source();
        
        this.setState({
            loading: true, 
            showError: false, 
            cancelToken: source,
            filter: filter,
            filterMenuEl: null
        });

        let requestData = {
            fileId: fileId,
            type: filter
        };
        
        Api.getPdfFileHeatmap(requestData, source).then(data => {
            this.setState({
                heatmap: data.heatmap,
                loading: false,
            });
        }).catch(err => {
            console.log(err);
        });
    }
    getVisitorInfo(visitorId){
        const source = axios.CancelToken.source();
        
        this.setState({
            loadingVisitorInfo: true, 
            showError: false, 
            cancelToken: source,
        });

        let requestData = {
            visit_id: visitorId
        };
        
        Api.getPdfFileActivity(requestData, source).then(data => {
            this.setState({
                visitor_info: data.visitor_info,
                loadingVisitorInfo: false,
            });
        }).catch(err => {
            console.log(err);
        });
    }
    getTrProps(state, rowInfo){
        return {
            onClick: (e) => this.getVisitorInfo(rowInfo.original.id),
        }
    }
    getTrGroupProps(state, rowInfo){
        if (rowInfo && rowInfo.row) {
            return {
                className: (rowInfo.original.id === 0 ? 'frozen_row' : '')
            }
        }else{
            return {}
        }
    }
    getNoDataProps(){
        return { style: { display: 'none' } };
    }
    getColumns(){
        let columns = [
            {
                Header: "Email",
                accessor: "email",
                headerClassName: "hd_email increase_width",
                className: "hd_email increase_width td_email",
                sortable: false
            },
            {
                Header: "Time Spent",
                accessor: "time_spent",
                headerClassName: "hd_timespent",
                className: "hd_timespent td_timespent",
                sortable: false
            },
            
        ];

        return columns;
    }
    getTableData(){
        const { recent_visits } = this.state;
        if(recent_visits === null){
            return [];
        }
        let tableData = [];
        recent_visits.map(visit => {
            let visitArray = {
                id: visit.visit_id,
                email: (
                    <div className="row">
                        <span className="user-icon">
                            { visit.email.charAt(0) }
                        </span>
                        <div>
                            <p className="email">{visit.email}</p>
                            <p className="views">{visit.created_at}</p>
                        </div>
                    </div>
                ),
                time_spent: (
                    <div className="row icon-column">
                        <AccessTimeIcon/> { visit.time_spent }
                    </div>
                ),
            };
            tableData.push(visitArray);
            return null;
        });
        return tableData;
    }
    onTabChange(urlTab){
        if(urlTab === '0'){
            this.loadPdfFileActivity();  
            this.setState({activeTab:0})
        }else if(urlTab === '1'){
            this.loadPdfFilePerformance();  
            this.setState({activeTab:1})
        }else if(urlTab === '2'){
            this.loadPdfFileHeatmap('views');
            this.setState({activeTab:2})
        }
    }
    fileHeader(){
        const { classes } = this.props;
        const { activeTab, file_info } = this.state;

        return (
            <GridContainer className={classes.controls+" pdf-analytics-header"}>
                <GridItem className="file-name">
                    <InsertDriveFileIcon /> <h4>{file_info.name}</h4>
                </GridItem>
                <GridItem className={classes.controlsTabs+" tabs"}>
                    <div className='sd-custom-tabs'>
                        <div className={'sd-custom-tab '+(activeTab === 0 ? 'active': '')} onClick={() => this.onTabChange("0")}>
                            <span>Activity</span>
                        </div>
                        <div className={'sd-custom-tab '+(activeTab === 1 ? 'active': '')} onClick={() => this.onTabChange("1")}>
                            <span>Performance</span>
                        </div>
                        <div className={'sd-custom-tab '+(activeTab === 2 ? 'active': '')} onClick={() => this.onTabChange("2")}>
                            <span>Heatmap</span>
                        </div>
                    </div>
                </GridItem>
            </GridContainer>
        )
    }
    renderRecentVisits(){
        const { classes } = this.props;
        const { loading, limit } = this.state;
        const tableData = this.getTableData();

        return (
            <div className="section-container recent-visits-section">
                <h4 className="section-title">Recent Visits</h4>
                <div className="section-content">
                    <div className={classes.files}>
                        {
                            loading ?
                                <LoaderComponent color="custom" align="center" />
                            :
                                <ReactTable
                                    columns={this.getColumns()}
                                    data={tableData}
                                    pageSizeOptions={[500]}
                                    defaultPageSize={limit}
                                    showPaginationTop={false}
                                    minRows={0}
                                    showPaginationBottom={false}
                                    className={"-striped -highlight "+ (loading ? classes.loading : "")+" "+classes.filesTable}
                                    getTrProps={(state, rowInfo) => this.getTrProps(state, rowInfo)}
                                    getTrGroupProps={(state, rowInfo) => this.getTrGroupProps(state, rowInfo)}
                                    getNoDataProps={() => this.getNoDataProps()}
                                />
                        }
                    </div>
                </div>
            </div>
        )
    }
    renderVisitorInfo() {
        const { classes } = this.props;
        const { visitor_info, loading, loadingVisitorInfo } = this.state;

        return (
            <div className="section-container visitor-info-section">
                <h4 className="section-title">Visitor Info</h4>
                <div className="section-content">
                    {
                        visitor_info === null ?
                            <div className={classes.noData}>No data</div>
                        : loading || loadingVisitorInfo ?
                            <LoaderComponent color="custom" align="center" />
                        :
                            <>
                                <div className="row">
                                    <p className="name"><EmailOutlinedIcon /> {visitor_info.email}</p>
                                    <p className={"date"}>Last accessed: {visitor_info.last_accessed}</p>
                                </div>
                                {
                                    visitor_info.pages && visitor_info.pages.length > 0 ? 
                                        visitor_info.pages.map((page, key) => (
                                            <div key={key} className="row">
                                                <p className="name"><InsertDriveFileOutlinedIcon /> Page: {page.page}</p>
                                                <p className={"date"}><AccessTimeIcon /> Time spent: {page.time_spent}</p>
                                            </div>
                                        ))
                                    :
                                        <div className={classes.noData}>No data</div>
                                }
                            </>
                    }
                </div>
            </div>
        );
    }
    renderHighlights(){
        return (
            <div className="section-container highlights-section">
                <h4 className="section-title">Highlights</h4>
                <div className="section-content">
                    <GridContainer>
                        <GridItem xs={12} sm={6}>
                            { this.renderCoreMetrics() }
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                            { this.renderTopPages() }
                        </GridItem>
                    </GridContainer>
                </div>
            </div>
        )
    }
    renderCoreMetrics(){
        const { total_visits, avg_viewed } = this.state;

        return (
            <div className="inner-section core-metrics-section">
                <h5 className="section-title">Core Metrics</h5>
                <div className="section-content">
                    <div className='boxes-list'>
                        <div className="box">
                            <p>Avg. Viewed</p>
                            <p className='count'>{avg_viewed}%</p>
                        </div>
                        <div className="box">
                            <p>Total Visits</p>
                            <p className='count'>{total_visits}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    renderTopPages(){
        const { top_pages } = this.state;
        const { classes } = this.props;

        return (
            <div className="inner-section top-pages-section">
                <h5 className="section-title">Top Pages (by total time spent per page)</h5>
                <div className="section-content">
                    <div className='boxes-list'>
                        {
                            top_pages && top_pages.length > 0 ? 
                                top_pages.map((page, key) => (
                                    <div key={key} className="box">
                                        <p>Page {page.page} <span>visits: {page.visits}</span></p>
                                        <p className='count'>{page.total_time}</p>
                                    </div>
                                ))
                            : 
                                <div className={classes.noData}>No data</div>
                        }
                    </div>
                </div>
            </div>
        )
    }
    renderTimePerPage(){
        const  { time_per_page } = this.state;

        let chartData = [];
        if(time_per_page){
            chartData = {
                labels: time_per_page.map(item => item.page),
                series: [time_per_page.map(item => item.avg_seconds)]
            };
        }

        const options = {
            low: 0,
            showArea: true
        };

        return (
            <div className="section-container time-per-page-section">
                <h4 className="section-title">Time per page (average seconds per visit)</h4>
                <div className="section-content">
                    <ChartistGraph data={chartData} options={options} type="Line" />
                </div>
            </div>
        )
    }
    renderDropOffReport(){
        const  { drop_off_report } = this.state;
        
        let chartData = [];
        if(drop_off_report){
            chartData = {
                labels: drop_off_report.map(item => item.page),
                series: [drop_off_report.map(item => item.percent)]
            };
        }

        const options = {
            low: 0,
            showArea: true
        };

        return (
            <div className="section-container drop-off-section">
                <h4 className="section-title">Drop-off report (percent of visits reaching pages)</h4>
                <div className="section-content">
                    <ChartistGraph data={chartData} options={options} type="Line" />
                </div>
            </div>
        )
    }
    renderHeatMap(){
        const { heatmap } = this.state;
        const { classes } = this.props;

        return (
            <div className="section-container heatmap-section">
                <div className="header">
                    <h4 className="section-title">{this.getFilterMenuText()} per page</h4>
                    <Button className="filter" color="transparent" aria-controls="filter-menu" aria-haspopup="true" onClick={(event) => this.onFilterMenu(event)}>
                        {this.getFilterMenuText()}
                        <svg className='right-icon' width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.95387 5.78032C4.70283 6.07323 4.29516 6.07323 4.04413 5.78032L0.188273 1.28119C-0.0627584 0.988283 -0.0627584 0.512595 0.188273 0.219684C0.439305 -0.0732279 0.846982 -0.0732279 1.09801 0.219684L4.5 4.18922L7.90199 0.222027C8.15302 -0.0708846 8.56069 -0.0708846 8.81173 0.222027C9.06276 0.514938 9.06276 0.990627 8.81173 1.28354L4.95587 5.78266L4.95387 5.78032Z"/>
                        </svg>
                    </Button>
                    {this.renderFilterMenu()}
                </div>
                <div className="section-content">
                    <div className='pages-list'>
                        {
                            heatmap && heatmap.length > 0 ? 
                                heatmap.map((page, key) => (
                                    <div key={key} className="page">
                                        <div className="box">
                                            <p>{page.page}</p>
                                        </div>
                                        <p className='count'><span>{page.value}</span></p>
                                    </div>
                                ))
                            : 
                                <div className={classes.noData}>No data</div>
                        }
                    </div>
                </div>
            </div>
        )
    }
    onCloseFilterMenu(status = false){
        this.setState({
            filterMenuEl: null,
        });
    }
    onFilterMenu(event){
        this.setState({
            filterMenuEl: event.currentTarget
        });
    }
    renderFilterMenu(){
        const { filterMenuEl } = this.state;
        const { classes } = this.props;

        return (
            <Menu
                id="source-menu"
                anchorEl={filterMenuEl}
                keepMounted
                open={Boolean(filterMenuEl)}
                onClose={() => this.onCloseFilterMenu()}
                className={classes.createMenu}
                PaperProps={{
                    style: {
                        marginTop: '40px',
                    },
                }}
            >
                <MuiMenuItem onClick={() => this.loadPdfFileHeatmap("views")} className='folder-menu'>
                    Average Views
                </MuiMenuItem>
                <MuiMenuItem onClick={() => this.loadPdfFileHeatmap("time_spent")} className='folder-menu'>
                    Total Time Spent
                </MuiMenuItem>
            </Menu>
        )
    }
    getFilterMenuText(){
        const { filter } = this.state;

        let text = 'Average views';
        if(filter === 'time_spent'){
            text = 'Total time spent';
        }else if(filter === 'views'){
            text = 'Average views'
        }

        return text;
    }
    render() {
        const { classes } = this.props;
        const { authorized } = this.store.getState();
        const { loading, file_info, activeTab } = this.state;

        if(!authorized){
            return (
                <div className={classes.main}>
                    <BackgroundSlider store={this.store} />
                    <Helmet>
                        <title>{process.env.REACT_APP_TITLE}</title>
                    </Helmet>
                </div>
            )
        }
        return (
            <div className={classes.main}>
                <div className={classes.container+" "+classes.pdfAnalyticsMainContainer}>
                    <div className={classes.content}>
                        {
                            file_info === null && loading ? 
                                <LoaderComponent color="custom" align="center" />
                            : file_info === null ?
                                <div className={classes.noData}>No data</div>
                            :
                                <GridItem>
                                    <div className={classes.pdfAnalyticsContainer}>
                                        { this.fileHeader() }
                                        {
                                            loading ?
                                                <LoaderComponent color="custom" align="center" />
                                            :
                                                activeTab === 0 ?
                                                    <GridContainer>
                                                        <GridItem xs={12} sm={6} lg={8}>
                                                            { this.renderRecentVisits() }
                                                        </GridItem>
                                                        <GridItem xs={12} sm={6} lg={4}>
                                                            { this.renderVisitorInfo() }
                                                        </GridItem>
                                                    </GridContainer>
                                                : activeTab === 1 ?
                                                    <GridContainer>
                                                        <GridItem xs={12}>
                                                            { this.renderHighlights() }
                                                        </GridItem>
                                                        <GridItem xs={12} sm={6}>
                                                            { this.renderTimePerPage() }
                                                        </GridItem>
                                                        <GridItem xs={12} sm={6}>
                                                            { this.renderDropOffReport() }
                                                        </GridItem>
                                                    </GridContainer>
                                                : activeTab === 2 ?
                                                    <GridContainer>
                                                        <GridItem xs={12}>
                                                            { this.renderHeatMap() }
                                                        </GridItem>
                                                    </GridContainer>
                                                :
                                                    <></>
                                        }
                                    </div>
                                </GridItem>
                        }
                    </div>
                </div>
                <Helmet>
                    <title>{process.env.REACT_APP_TITLE}</title>
                </Helmet>
            </div>
        )
    }
}

PdfFileAnalytics.propTypes = {
    classes: PropTypes.object
};

export default withStyles(userHomePageStyle)(PdfFileAnalytics);
